/**
 * The tick shape every cutscene player (the intro and the career-milestone
 * scenes alike) runs from: a `TtmCommand` stream chunked at each
 * `0x0FF0 FINISH FRAME`, with the delay that follows it already resolved to
 * milliseconds by the interpreter's delay-persistence model
 * (`packages/formats`' `iterateTtmRun`, docs/formats/ttm-animation.md's
 * Timing section).
 *
 * Moved out of `shell/intro/intro-ticks.ts` so a script other than
 * `TITLE.TTM` can be turned into the same shape — see that module, now a
 * thin re-export, for why the name there is kept.
 */

import { iterateTtmRun, NULL_TTM_ENV, type TtmCommand, type TtmEnv, type TtmScript } from "@red-opus/formats";

export interface CutsceneTick {
  readonly index: number;
  readonly commands: readonly TtmCommand[];
  /** Hold *after* this tick's commands, per the interpreter's delay-persistence model. */
  readonly delayMs: number;
}

export function ticksFromScript(script: TtmScript, env: TtmEnv = NULL_TTM_ENV): CutsceneTick[] {
  return [...iterateTtmRun(script, env)].map((tick) => ({
    index: tick.frameIndex,
    commands: tick.commands,
    delayMs: tick.delayMs,
  }));
}

export function totalDurationMs(ticks: readonly CutsceneTick[]): number {
  return ticks.reduce((sum, tick) => sum + tick.delayMs, 0);
}
